import { render, staticRenderFns } from "./parkingConfiguration.vue?vue&type=template&id=13974ba8&scoped=true"
import script from "./parkingConfiguration.vue?vue&type=script&lang=js"
export * from "./parkingConfiguration.vue?vue&type=script&lang=js"
import style0 from "./parkingConfiguration.vue?vue&type=style&index=0&id=13974ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13974ba8",
  null
  
)

export default component.exports